module.exports = __webpack_public_path__ + "img/ARISTOCRAT.9257fc2d.png";